import script from "./FakeSelectWithTooltip.vue?vue&type=script&lang=ts&setup=true"
export * from "./FakeSelectWithTooltip.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__